export function parseAdminDate(value) {
  if (value === null || value === undefined || value === '') return null
  let normalized = value
  const timestamp = String(value).trim()

  // Jackson Instant values can include fractional epoch seconds.
  if (/^\d{10,13}(?:\.\d+)?$/.test(timestamp)) normalized = Number(timestamp) * (timestamp.split('.')[0].length <= 10 ? 1000 : 1)
  else if (typeof value === 'string') {
    normalized = value.trim().replace(' ', 'T')
    if (/^\d{4}-\d{2}-\d{2}$/.test(normalized)) normalized += 'T00:00:00+03:00'
    else if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2}(\.\d+)?)?$/.test(normalized)) normalized += '+03:00'
  }
  const date = new Date(normalized)

  return Number.isNaN(date.getTime()) ? null : date
}

export function formatAdminDate(value, compact = false) {
  const date = parseAdminDate(value)

  return date ? date.toLocaleString('tr-TR', {
    timeZone: 'Europe/Istanbul', year: compact ? undefined : 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23',
  }) : '-'
}
